import React from "react";

/**
 * O que deu errado com a nota, em linguagem de usuário (BDM-887).
 *
 * O backend monta o `friendly_problem` (título, motivo, ação e código do
 * fisco) — aqui é só a apresentação, igual na nota, no pedido e no modal
 * que a lista abre.
 */
export const DocumentProblem = ({ problem }) => {
    if (!problem) return null;

    return (
        <div className={`fiscal-document-problem`}>
            <strong>{problem.title}</strong>
            <p>{problem.message}</p>
            <p className={`problem-action`}>{problem.action}</p>
            {problem.code && <span className={`problem-code`}>Código do fisco: {problem.code}</span>}
        </div>
    );
};

export default DocumentProblem;
